/* eslint-disable no-plusplus,no-nested-ternary */
import { withTranslation } from 'react-i18next'
import { ProseMirror } from '@progress/kendo-react-editor'

export const InsertImagePlugin = onInsert =>
  new ProseMirror.Plugin({
    props: {
      handleDOMEvents: {
        paste: (view, event) => insertImages(view, event, onInsert),
        drop: (view, event) => insertImages(view, event, onInsert),
      },
    },
    key: new ProseMirror.PluginKey('insert-image-plugin'),
  })

const insertImages = (view, event, onInsert) => {
  const items =
    (event.clipboardData && event.clipboardData.items) ||
    (event.dataTransfer && event.dataTransfer.files)
  const files = []
  let file
  if (items) {
    for (let i = 0; i < items.length; i++) {
      file =
        items[i].type.indexOf('image') !== -1
          ? 'getAsFile' in items[i]
            ? items[i].getAsFile()
            : items[i]
          : null

      if (file) {
        files.push(file)
      }
    }

    if (files.length) {
      event.preventDefault()
    }
  }
  return onInsert({
    view,
    files,
    event,
  })
}
export default withTranslation()({ InsertImagePlugin })
